<div class="notification-header-wrapper">
  <span class="notification-title-label">{{title}}</span>
  <span class="notification-date-label">{{formattedDate}}</span>
</div>

<p class="notification-content-text">{{content}}</p>

<div class="d-inline-flex justify-content-between">
  <button type="button" class="btn btn-link mark-as-read-button" *ngIf="isMarkAsReadButtonVisible" (click)="markAsRead()">
    <ng-container *ngIf="loading else markAsReadTemplate">
      <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
      <span class="visually-hidden">Chargement...</span>
    </ng-container>
    <ng-template #markAsReadTemplate>
      Marquer comme lu
    </ng-template>
  </button>

  <button *ngIf="additionalButton" type="button" class="btn btn-link" (click)="doAdditionalButton()">
    <ng-container *ngIf="loading else additionalButtonTemplate">
      <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
      <span class="visually-hidden">Chargement...</span>
    </ng-container>
    <ng-template #additionalButtonTemplate>
      {{additionalButton}}
    </ng-template>
  </button>
</div>
